var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.587 13.873c-1.934-.66-6.254-3.413-6.254-8.08 0-2.06 1.66-3.726 3.707-3.726 1.213 0 2.287.586 2.96 1.493a3.686 3.686 0 012.96-1.493c2.047 0 3.707 1.666 3.707 3.726 0 4.667-4.32 7.42-6.254 8.08-.226.08-.6.08-.826 0z",
    stroke: "#403D5A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  })));
}

export default SvgHeart;